import { TagResponse } from "@every.org/common/src/codecs/entities";
import {
  CAUSE_ILLUSTRATION_BG_PALETTE,
  colorPalette,
} from "@every.org/common/src/display/palette";
import {
  cloudinaryIdToTransformId,
  BASIS_GROTESQUE_CLOUDINARY_ID,
} from "@every.org/common/src/helpers/cloudinary";

import { TagFetchStatus } from "src/context/TagContext/types";
import {
  DEFAULT_SHARE_IMAGE_CLOUDINARY_PARAMS,
  OPENGRAPH_DIMENSIONS,
} from "src/utility/opengraph";

export function buildOgDescription(
  title: string,
  topNonprofits: string[] | undefined
) {
  return `Discover nonprofits ${
    topNonprofits ? `like ${topNonprofits.join(", ")} ` : ""
  }that are supporting ${title}. Explore, donate, and share.`;
}

const TAG_SHARE_FRAME_HEIGHT = 195;

export function getTagShareCloudinaryParams(
  tag: TagResponse | TagFetchStatus.TAG_NOT_FOUND | TagFetchStatus.FETCHING_TAG
) {
  return tag === TagFetchStatus.FETCHING_TAG ||
    tag === TagFetchStatus.TAG_NOT_FOUND
    ? DEFAULT_SHARE_IMAGE_CLOUDINARY_PARAMS
    : tag.shareImageCloudinaryId
    ? { cloudinaryId: tag.shareImageCloudinaryId }
    : tag.tagImageCloudinaryId
    ? {
        cloudinaryId: "tag-share-frame", // shows "every.org" at top of image
        transforms: [
          // create background with cause category color that sits below
          // the "every.org" dark frame at the top of the share image, by
          // sizing a gray pixel to the intended size and then coloring it
          `l_graypixel,w_${OPENGRAPH_DIMENSIONS.width},h_${
            OPENGRAPH_DIMENSIONS.height - TAG_SHARE_FRAME_HEIGHT
          },g_south,e_colorize,co_rgb:${CAUSE_ILLUSTRATION_BG_PALETTE[
            tag.causeCategory
          ].replace(/^#/, "")}`,
          // add cause category text
          // TODO: support long titles by wrapping, shrinking font size
          // (manually via heuristics like word/full title length)
          `l_text:${cloudinaryIdToTransformId(
            BASIS_GROTESQUE_CLOUDINARY_ID
          )}_80:${encodeURIComponent(
            tag.title
          )},g_south,y_72,co_rgb:${colorPalette.blackWarmHex.replace(
            /^#/,
            ""
          )}`,
          // overlay tag image over cause category color
          `l_${cloudinaryIdToTransformId(
            tag.tagImageCloudinaryId
          )},w_272,h_272,y_40`,
        ],
        applySizeAfterTransforms: true,
      }
    : DEFAULT_SHARE_IMAGE_CLOUDINARY_PARAMS;
}
